import { useEffect } from "react";
import { useSelector } from "react-redux";
import "./toastContainer.scss";

import { toastData } from "@src/@slice/toastSlice";
import toast, { IToast } from "@src/utils/toast";

import CloseIcon from "@src/assets/images/icon/ic_stylehate_nor_24_white.png";
import { logEvent } from "@src/reactGa";
import { Icon } from "@src/shared/src";

export default function ToastContainer() {
  const { toasts } = useSelector(toastData);

  function removeToastById(toastId: number|string) {
    toast.remove(toastId);
  }

  return (
    <div className="app-toast-container">
      {toasts.map((toast) => (
        <Toast key={toast.id} item={toast} removeToast={() => removeToastById(toast.id)} />
      ))}
    </div>
  );
}

function Toast(props: { item: IToast; removeToast: () => void }) {
  const { item, removeToast } = props;

	const clickToast = () => {
		logEvent("notice", {
			component: item.isSnackbar ? "snackbar" : "toast",
			behavior: "click",
			title: item.message,
			page_path: window.location.pathname
		})
	}
  useEffect(() => {
    const _removeTime = item.removeTime || 5000;
    const timeout = setTimeout(() => removeToast(), _removeTime);

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line
  }, []);

  const inlineStyle = {};
  if (item.bottomPosition) {
    inlineStyle["bottom"] = item.bottomPosition;
  }

  return (
    <div
      className={`
        toast
        ${item.type === "error" ? "toast-error" : "toast-success"}
        ${item.isSnackbar ? "snackbar" : ""}
      `}
      style={{
        ...inlineStyle,
      }}
    >
      <p
        className="toast-message"
        onClick={() => {
          if (item.link) {
            clickToast();
            if (item.link.target) {
              window.open(item.link.url, item.link.target);
            } else {
              window.location.href = item.link.url;
            }
          }
        }}
      >
        {item.icon 
        ? <>
          <i style={{display: 'inline-flex', verticalAlign: 'middle'}}>
            <Icon name={item.icon.name} size={item.icon.size || 18} />  
          </i> {item.message}
        </>
        : item.message}
      </p>

      {(item.link !== undefined  && !item.isSnackbar) && (
        <a href={item.link.url} className="toast-link" onClick={clickToast} target={item.link.target ? item.link.target : "_self"}>
          {item.link.text}
        </a>
      )}

      {(item.isShowClose === true && !item.isSnackbar) && (
        <button onClick={removeToast} className="btn btn-icon toast-close-btn">
          <img src={CloseIcon} alt="닫기" />
        </button>
      )}
    </div>
  );
}
